export const truncateTo20 = (str: string) => {
  return str.slice(0, 20) + '...';
};

export const truncateTo35 = (str: string) => {
  return str.slice(0, 35) + '...';
};
